import { customsAugmentationSettingsSchema } from "@redotech/redo-conversion-settings-common/customs-settings";
import * as z from "zod";

export const updateCustomsAugmentationSettings = {
  name: "updateCustomsAugmentationSettings" as const,
  input: customsAugmentationSettingsSchema,
  output: z.object({}),
};
